import { IApiError } from '@/models/apiError.model';
import { IPagination } from '@/models/pagination.model';
import {
  IOrder,
  IOrderDetails,
  IOrderListMeta,
  IOrderNovaPoshtaDepartment,
  IOrderProduct,
} from '@/models/orders.model';
import { IOrderManager } from '@/models/admins.model';
import { TGetOrdersQuery } from '../helpers';

export const ORDERS_SLICE_NAME = 'orders';

export interface OrdersState {
  ordersList: {
    data: IOrder[];
    meta: IOrderListMeta;
  } | null;
  orderProductsList: {
    data: IOrderProduct[];
    meta: IPagination;
  } | null;
  novaPoshtaDepartments: IOrderNovaPoshtaDepartment[] | null;
  managers: IOrderManager[];
  order: IOrderDetails | null;
  isLoading: boolean;
  isUpdatingProducts: boolean;
  isLoadingOrderProducts: boolean;
  isLoadingNovaPoshta: boolean;
  query: TGetOrdersQuery | null;
  error: IApiError | null;
  newCount: number;
  isNewCountLoading: boolean;
}

export const initialState: OrdersState = {
  ordersList: null,
  orderProductsList: null,
  novaPoshtaDepartments: null,
  managers: [],
  order: null,
  isLoading: false,
  isUpdatingProducts: false,
  isLoadingOrderProducts: false,
  isLoadingNovaPoshta: false,
  query: null,
  error: null,
  newCount: 0,
  isNewCountLoading: false,
};
